import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { ReactComponent as DisqualifyIcon } from '../../../../../assets/icons/not_interested_light.svg';
import EventAuthor from '../eventAuthor';
import EventDate from '../eventDate';
import useStyles from '../styles';

const Disqualified = ({ translations, record }) => {
  const classes = useStyles();

  return (
    <div className={classes.authorEvent}>
      <div className={classes.eventHeader}>
        <div className={classes.eventInfo}>
          <div className={classes.icon}>
            <DisqualifyIcon
              className={classNames(classes.eventIcon, classes.disqualifyIcon)}
            />
          </div>
          <EventAuthor translations={translations} record={record} />
        </div>
        <EventDate record={record} />
      </div>
      <Typography
        className={classes.eventDetails}
        variant="body1"
        component="div"
      >
        {`${translations.disqualifiedOnStep} `}
        <Typography variant="subtitle1" component="span">
          {record.step_title}
        </Typography>
      </Typography>
    </div>
  );
};

Disqualified.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  record: PropTypes.object.isRequired,
};

export default Disqualified;
